import React, { useState, useEffect, useRef } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Modal } from 'bootstrap';
import { useNavigate } from "react-router-dom";
import clientHttp from '../../components/ClientHttp';
import Pagination from '../../components/Pagination';
import DownloadStatusList from './DownloadStatusList';
import { getBankAccountList, getBankNoList } from '../../components/DataList';
import { formatDate } from "../../components/DateUtil";

export default function DownloadStatusContent() {
    const currentDate = new Date();
    const [fromDate, setFromDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()));
    const [toDate, setToDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()));
    const [data, setData] = useState(null);
    const [isSearchLoading, setIsSearchLoading] = useState(false)
    const [error, setError] = useState('');
    const [errorClass, setErrorClass] = useState('');
    // DatePicker
    const fromDateCalendar = useRef(null)
    const toDateCalendar = useRef(null)
    async function openFromDateCalendar() { fromDateCalendar.current.setFocus(true); }
    async function openToDateCalendar() { toDateCalendar.current.setFocus(true); }
    // rerun
    const [rerunBank, setRerunBank] = useState('')
    const [rerunBankNo, setRerunBankNo] = useState('')
    const [rerunMessage, setRerunMessage] = useState('');
    const [rerunMessageClass, setRerunMessageClass] = useState('');
    const [isRerun, setIsRerun] = useState(false)
    const [isRerunCompleted, setIsRerunCompleted] = useState(false)

    let navigate = useNavigate()
    
    // change page
    const [currentPage, setCurrentPage] = useState(1);
    const [total, setTotal] = useState(0)
    const [pageSize, setPageSize] = useState(10);
    const onPageChange = (page) => {
        setCurrentPage(page);
        console.log('select page: ' + page)
        searchSubmit(page)
    }
    const selectPageSize = (e) => { setPageSize(e.target.value) }

    // bank
    const [bank, setBank] = useState('ALL')
    const [bankNo, setBankNo] = useState('ALL')
    const selectBank = (e) => {
        setBank(e.target.value)
        setBankNo('ALL')
    }
    const selectBankNo = (e) => {
        setBankNo(e.target.value)
    }

    async function searchSubmit(page) {
        setCurrentPage(page);
        setIsSearchLoading(true)
        let isSuccess = false
        // clear data
        setError('')
        setErrorClass('')
        setData(null)

        // prepare parameters
        console.log('call search api with parameters:' + fromDate, toDate, bank, bankNo, page, pageSize)
        const _fromDate = fromDate.getFullYear() + '-' + (fromDate.getMonth() + 1) + '-' + fromDate.getDate();
        const toDate2 = new Date(toDate)
        toDate2.setDate(toDate2.getDate() + 1)
        const _toDate = toDate2.getFullYear() + '-' + (toDate2.getMonth() + 1) + '-' + toDate2.getDate();
        const formData = {
            fromDate: _fromDate,
            toDate: _toDate,
            bank: bank,
            bankNo: bankNo,
            page: page,
            pageSize: pageSize,
        }
        console.log(formData)

        // call search api
        let token = localStorage.getItem('token')
        await clientHttp.post('onlinepayment/v1/downloadstatus_list', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
            console.log('response status: ' + response.status)
            isSuccess = true // ignore no data popup
            if (response.data.status === 'success') {
                console.log('display download status list')
                setTotal(response.data.total)
                setData(response.data.data)
                //console.log(response)
                setErrorClass('text-black')
            } else {
                console.log('get download status list failed: ' + response.data.message)
                setError(response.data.message)
                setErrorClass('text-danger')
            }

        }).catch(err => {
            console.log('error: ', err.message)
            if (err.response.status === 401 || err.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('get download status list failed: ' + err.message)
                setError(err.message)
                setErrorClass('text-danger')
            }
        })

        if (!isSuccess) {
            let errorMessageModal = new Modal('#errorMessageModal')
            errorMessageModal.show()
        }
        setIsSearchLoading(false)
    }

    async function rerunDownload() {
        console.log('[rerunDownload] rerun download ')
        setRerunMessage('')
        setRerunMessageClass('text-danger')

        if (bank !== 'ALL') {
            setRerunBank(bank)
        }
        if (bankNo !== 'ALL') {
            setRerunBankNo(bankNo)
        }
        if (bank === 'ALL' || bankNo === 'ALL') {
            setIsRerunCompleted(true)
            setRerunMessage('Please select Bank and Bank No.')
        } else {
            setIsRerunCompleted(false)
        }

        let rerunDownloadModal = new Modal('#rerunDownloadModal')
        rerunDownloadModal.show()
    }

    async function onRerun() {
        setIsRerun(true)
        setIsRerunCompleted(false)

        // prepare parameters
        console.log('call search api with parameters:' + fromDate, toDate, bank, bankNo)
        const _fromDate = fromDate.getFullYear() + '-' + (fromDate.getMonth() + 1) + '-' + fromDate.getDate();
        const _toDate = toDate.getFullYear() + '-' + (toDate.getMonth() + 1) + '-' + toDate.getDate();
        const formData = {
            fromDate: _fromDate,
            toDate: _toDate,
            bank: bank,
            bankNo: bankNo,
            user: localStorage.getItem('name')
        }
        console.log('call re-run api with parameters: ')
        console.log(formData)

        // call search api
        let token = localStorage.getItem('token')
        await clientHttp.post('onlinepayment/v1/downloadstatus_rerun', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
            console.log(response)
            console.log('response status: ' + response.status)
            if (response.data.status === 'success') {
                console.log('re-run success')

                setRerunMessageClass('text-success')
                setRerunMessage(response.data.message)
            } else {
                console.log('re-run failed: ' + response.data.message)
                setRerunMessage(response.data.message)
            }
        }).catch(err => {
            console.log('error: ', err.message)
            if (err.response.status === 401 || err.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('re-run failed: ' + err.message)
                setRerunMessage(err.message)
            }
        })

        //await new Promise( res => setTimeout(res, 1000) );
        setIsRerunCompleted(true)
        setIsRerun(false)
    }

    // load data list for dropdown
    const [bankNameList, setBankNameList] = useState([])
    const [bankNoList, setBankNoList] = useState([])
    useEffect(() => {
        // get bank list
        (async () => {
            console.log('load bank list')
            setBankNameList(await getBankAccountList())

            searchSubmit(1)
        })()

    }, [])

    useEffect(() => {
        if (bank && bank !== 'ALL') {
            (async () => {
                console.log('load bank no of ' + bank)
                let list = await getBankNoList(bank)
                console.log(list)
                setBankNoList(list)
            })()
        }
    }, [bank])

    return (
        <>
            <div className="page-header">
            </div>
            <div className="row">
                <div className="col-md-12">
                    {/* start form */}
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group ">
                                            <span className="input-group-text">From Date:</span>
                                            <DatePicker className="form-control" ref={fromDateCalendar} selected={fromDate} onChange={(date) => setFromDate(date)} dateFormat="dd/MM/yyyy" />
                                            <span className="input-group-text" onClick={openFromDateCalendar.bind(this)}><i className="bi bi-calendar-date"></i></span>

                                            <span className="input-group-text ms-3">To Date:</span>
                                            <DatePicker className="form-control" ref={toDateCalendar} selected={toDate} onChange={(date) => setToDate(date)} dateFormat="dd/MM/yyyy" />
                                            <span className="input-group-text" onClick={openToDateCalendar.bind(this)}><i className="bi bi-calendar-date"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-1 col-md-1 col-sm-1">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <select className="form-select" defaultValue={pageSize} onChange={selectPageSize}>
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                                <option value="500">500</option>
                                                <option value="1000">1000</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                                    <div className="form-group">
                                        {isSearchLoading ?
                                            <button className="btn btn-black btn-border btn-primary" style={{ "width": "120px" }} type="button">
                                                <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                                <span role="status" className="ms-3">Loading...</span>
                                            </button>
                                            :
                                            <button type="button" className="btn btn-primary" style={{ "width": "120px" }} onClick={searchSubmit.bind(this, 1)}>
                                                <i className="bi bi-search me-2"></i> Search
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group ">
                                            <span className="input-group-text">Bank:</span>
                                            <select className="form-select" value={bank} onChange={selectBank}>
                                                <option value="ALL">All</option>
                                                {
                                                    bankNameList?.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.bankabv}>{item.bankabv}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <span className="input-group-text">Bank No:</span>
                                            <select className="form-select" value={bankNo} onChange={selectBankNo}>
                                                <option value="ALL">All</option>
                                                {
                                                    bankNoList?.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.bankno}>{item.bankno}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-1 col-md-1 col-sm-1">
                                    <div className="form-group">
                                        <div className="input-group">
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <button type="button" className="btn btn-black btn-border" style={{ "width": "120px" }} onClick={rerunDownload.bind(this)}>
                                                <i className="bi bi-arrow-repeat me-2"></i> Re-Load
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* end form */}
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    {data && <DownloadStatusList data={data} />}
                </div>
            </div>

            {data &&
                <Pagination total={total} pageSize={pageSize} currentPage={currentPage} onPageChange={onPageChange} />
            }

            <div className='row'>
                <div className='col-md-12'>
                    <div className="modal fade" id="errorMessageModal" tabIndex="-1" >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <p className={errorClass}>{error}</p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="rerunDownloadModal" tabIndex="-1" aria-labelledby="rerunDownloadLabel">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="rerunDownloadLabel">Re-Load Data</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">From Date :</label>
                                    <div className="col-sm-9 mt-2">{formatDate(fromDate)}</div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">To Date :</label>
                                    <div className="col-sm-9 mt-2">{formatDate(toDate)}</div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Bank :</label>
                                    <div className="col-sm-9 mt-2">{rerunBank}</div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Bank No :</label>
                                    <div className="col-sm-9 mt-2">{rerunBankNo}</div>
                                </div>
                            </form>
                            <div className="mb-3">
                                <p className="mt-4 mb-6">
                                    <span className={rerunMessageClass}>{rerunMessage}</span>
                                </p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dark" data-bs-dismiss="modal">Close</button>
                            {isRerun ?
                                <button className="btn btn-primary" style={{ width: '120px' }} type="button">
                                    <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                    <span className="ms-3">Confirm</span>
                                </button>
                                : !isRerunCompleted &&
                                <button type="button" className="btn btn-primary" style={{ width: '120px' }} onClick={onRerun.bind(this)}>
                                    <i className="bi bi-check-circle"></i> Confirm
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}